export const metricAggregateMinutesInPast = 60;
export const metricHistoryHoursInPast = 24;

export enum MetricTypes {
  ExportPayoutRequestReverted = 1,
  SqsFundingExportMessageCount,
  SqsFundingExportMessagesDelayed,
  SqsFundingExportMessagesNotVisible,
  InvoiceExportStatusExporting,
  InvoiceExportStatusQueuedForExport,
  InvoiceExportStatusPreparingForExport,
  InvoiceDraftExportInProgress,
  InvoiceDraftExportReadyForFunding,
  InvoiceDraftExportStatusFundingToBank,
  SqsImageConversionRequestMessageCount,
  SqsImageConversionRequestDelayedMessages,
  SqsImageConversionRequestMessagesNotVisible,
  SqsImageConversionCompletedMessageCount,
  SqsImageConversionCompletedDelayedMessages,
  SqsImageConversionCompletedMessagesNotVisible,
}
